import { AppLayout } from "@/components/layout/AppLayout";
import { ResultsWorkflow } from "@/components/examination/ResultsWorkflow";
import { StudentExaminationView } from "@/components/examination/StudentExaminationView";
import { VerificationQueue } from "@/components/examination/VerificationQueue";
import { useAuth } from "@/contexts/AuthContext";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { canManageModule } from "@/lib/permissions";

const Examination = () => {
  const { roles, hasRole } = useAuth();
  const { mode } = useImpersonation();
  const isStudent = hasRole("student");
  const isSimulatingStudent = mode === "student_simulation";
  const showStudentView = isStudent || isSimulatingStudent;
  const canManageExamination = canManageModule(roles, "examination");

  return (
    <AppLayout>
      <div className="space-y-3 sm:space-y-4">
        <div className="page-header">
          <div>
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold">Examination</h1>
            <p className="text-muted-foreground text-sm">
              {showStudentView
                ? "View examination announcements and your results"
                : canManageExamination
                  ? "Manage results, templates, approvals, and publication"
                  : "Review assigned result batches and complete verification"}
            </p>
          </div>
        </div>
        {!showStudentView && <VerificationQueue />}
        {showStudentView ? <StudentExaminationView /> : canManageExamination ? <ResultsWorkflow /> : null}
      </div>
    </AppLayout>
  );
};

export default Examination;
